export default __webpack_public_path__ + "static/media/IconDesc_JumpPad.256.040112fe.png";